import * as React from "react"
import { SVGProps } from "react"
const MenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    // width={24}
    // height={18}
    viewBox="0 0 24 18"
    fill="currentColor"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.259 1.963H.74c-.196 0-.385-.104-.524-.288A1.162 1.162 0 0 1 0 .981c0-.26.078-.51.217-.694C.357.103.545 0 .741 0H23.26c.196 0 .385.103.524.287S24 .721 24 .981c0 .26-.078.51-.217.694-.14.184-.328.288-.524.288ZM23.259 9.982H.74c-.196 0-.385-.104-.524-.288A1.162 1.162 0 0 1 0 9c0-.26.078-.51.217-.694.14-.184.328-.287.524-.287H23.26c.196 0 .385.103.524.287S24 8.74 24 9c0 .26-.078.51-.217.694-.14.184-.328.288-.524.288ZM23.259 18H.74c-.196 0-.385-.104-.524-.288A1.162 1.162 0 0 1 0 17.018c0-.26.078-.51.217-.694.14-.184.328-.287.524-.287H23.26c.196 0 .385.104.524.288s.217.433.217.693c0 .26-.078.51-.217.694-.14.184-.328.288-.524.288Z"
    />
  </svg>
)
export default MenuIcon